<template>
  <div
    class="d-flex align-items-baseline"
  >
    <template>
      <div class="border-left">
        <b-button
          variant="tertiary"
          class="bulk-action-button ml-2 mr-1"
          @click="openActionConfirmationModal('publish')"
          :disabled="!canPublishArticles({
            ids: selectedIds,
          })"
          data-test="bulk-action-publish"
        >
          <i class="icon-btn fal fa-play" />
        </b-button>
        <b-button
          variant="tertiary"
          class="bulk-action-button mx-1"
          @click="openActionConfirmationModal('pause')"
          :disabled="!canPauseArticles({
            ids: selectedIds,
          })"
          data-test="bulk-action-pause"
        >
          <i class="icon-btn fal fa-pause" />
        </b-button>
        <b-button
          v-if="GET_IS_ADMIN"
          variant="tertiary"
          class="bulk-action-button mx-1"
          @click="openScheduleArticlesModal(selectedIds)"
          :disabled="!canScheduleArticles({
            ids: selectedIds,
          })"
          data-test="bulk-action-schedule"
        >
          <i class="icon-btn fal fa-clock" />
        </b-button>
        <b-button
          variant="tertiary"
          class="bulk-action-button ml-1 mr-2"
          @click="openLanguageChangeModal()"
          :disabled="!canChangeArticlesLanguage({
            ids: selectedIds,
          })"
          data-test="bulk-action-change-language"
        >
          <i class="icon-btn fal fa-globe" />
        </b-button>
      </div>
      <div class="border-left">
        <b-button
          variant="tertiary"
          class="bulk-action-button mx-2"
          @click="openActionConfirmationModal('delete')"
          :disabled="!canDeleteArticles({
            ids: selectedIds,
          })"
          data-test="bulk-action-delete"
        >
          <i class="icon-btn fa-light fa-trash-can" />
        </b-button>
      </div>
    </template>
    <language-change-modal
      @setNewSelectedLanguage="setNewSelectedLanguage(...arguments)"
    />
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

import LanguageChangeModal from '@/modules/content/components/ContentPage/LanguageChangeModal';

import ArticlesActionsMixins from '@/modules/content/components/ContentPage/mixins/ArticlesActionsMixins';
import * as authenticationTypes from '@/modules/authentication/store/types';

export default {
  name: 'ArticlesBulkActions',
  mixins: [
    ArticlesActionsMixins,
  ],
  components: {
    LanguageChangeModal,
  },
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
      required: true,
    },
    areAllArticlesSelected: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
      'selectedAdvertiser',
    ]),
    ...mapState('content', [
      'feedId',
    ]),
    ...mapGetters('authentication', [
      authenticationTypes.GET_IS_ADMIN,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_ARTICLE_BY_ID,
    ]),
  },
  methods: {
    ...mapActions('content', [
      contentTypes.FETCH_LANGUAGES,
    ]),
    async openLanguageChangeModal() {
      await this.FETCH_LANGUAGES();
      this.$root.$emit('bv::show::modal', 'language-change-modal');
    },
    openScheduleArticlesModal(ids) {
      const payload = {
        ids,
        isBulk: true,
      };
      if (this.areAllArticlesSelected) payload.areAllArticlesSelected = true;
      this.$emit('openScheduleArticlesModal', payload);
    },
    setNewSelectedLanguage(newLanguageId) {
      this.openActionConfirmationModal('change-language', newLanguageId);
    },
    openActionConfirmationModal(action, newLanguageId = null) {
      const payload = {
        action,
        ids: this.selectedIds,
      };
      if (newLanguageId) payload.newLanguageId = newLanguageId;
      if (this.areAllArticlesSelected) payload.areAllArticlesSelected = true;
      this.$emit('openActionConfirmationModal', payload);
    },
  },
};
</script>
<style lang="scss" scoped>
.bulk-action-button {
  padding: 0px 0.75rem;
  width: auto;
  min-width: unset;
  line-height: inherit;
  vertical-align: baseline;
}
.icon-btn {
  font-size: 1rem;
  &.fa-trash-can {
    color: $danger;
    &:hover {
      color: $danger-dark;
    }
  }
}
</style>
